export default class Scrolly {
  constructor(element) {
    this.element = element;
    this.options = {
      rootMargin: '0px',
    };

    this.init();
  }

  init() {
    const observer = new IntersectionObserver(
      this.watch.bind(this),
      this.options
    );

    const items = this.element.querySelectorAll('[data-scrolly]');
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      observer.observe(item);
    }
  }

  watch(entries, observer) {
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const target = entry.target;

      if (entry.isIntersecting) {
        const delay = target.dataset.delay;
        setTimeout(this.addScrolly, delay, target);

        if ("noRepeat" in this.element.dataset) {
          observer.unobserve(target); //Arrête l'animation au scroll après qu'elle soit fait la première fois
          console.log('element non observer');
        }
      } else {
        target.classList.remove('is-active');
      }
    }
  }

  addScrolly(target){
    target.classList.add('is-active');
  }
}
